/* eslint-disable */
import { useState } from 'react'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import jwtDecode from 'jwt-decode'
import { useNavigate } from 'react-router-dom'
import { EUserRole, userJWTData } from '../redux/user/userTypes'

interface AuthResponse {
  credential: string
}

interface AuthUserData {
  token?: string
  message?: string
}

interface UseAuthReturn {
  loading: boolean
  error: string
  handleAuth: (
    response: AuthResponse,
    ssoProvider: 'google' | 'microsoft' | 'apple'
  ) => Promise<void>
}

const useAuths = (url: string): UseAuthReturn => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()

  const loginRedirect = (navigateTo?: string) => {
    if (navigateTo) {
      navigate(navigateTo)
      return
    }
    navigate(0)
  }

  const handleAuth = async (
    response: AuthResponse,
    ssoProvider: 'google' | 'microsoft' | 'apple'
  ): Promise<void> => {
    setLoading(true)
    setError('') // Reset error before a new request
    try {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ credential: response.credential, ssoProvider }),
      })

      const data: AuthUserData = await res.json()

      if (res.ok && data?.token) {
        localStorage.setItem('token', data.token)

        // Decode JWT to get roles
        const { roles } = jwtDecode(data.token) as userJWTData

        await new Promise(resolve => setTimeout(resolve, 2000))

        setLoading(false)

        // Redirect based on role
        if (roles.includes(EUserRole.ROLE_SUPER_ADMIN)) {
          loginRedirect('/super-admin/dashboard')
          return
        }
        loginRedirect() // for normal roles
      } else {
        setLoading(false)
        const message = 'Authentication failed'
        setError(message)
        toast.error(message)
        console.error(data?.message)
      }
    } catch (error: any) {
      setLoading(false)
      setError(error.message)
      console.error(error.message)
    }
  }

  return { loading, error, handleAuth }
}

export default useAuths
